import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankRoundedIcon from '@material-ui/icons/CheckBoxOutlineBlankRounded';
import CheckBoxRoundedIcon from '@material-ui/icons/CheckBoxRounded';
import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { ThemeContext } from '../../../contexts/Theme';
import {
  focusRing,
  fontSize,
  lineHeight,
  neutral,
  radius,
  space,
  transition,
} from '../../../theme/tokens';
import { ItemLink, StaffRow } from '../../common/elements/Staff';
import { Button } from './Form';

export const QuestionList = styled.ol`
  padding: 0;
  margin: 0;
  list-style-type: none;
`;

export const QuestionLi = styled.li`
  display: grid;
  grid-template-columns: min-content auto min-content min-content;
  grid-template-rows: min-content min-content;
  grid-template-areas:
    'bullet text check delete'
    '. error . .';
  align-items: center;
  gap: ${space[2]};
  margin: ${space[3]} 0;
`;

export const AnswerLi = styled(QuestionLi)`
  /* last column holds the teacher-only checkbox */
  grid-template-columns: min-content minmax(0, 1fr) 4.4rem;
  grid-template-rows: min-content min-content min-content;
  grid-template-areas:
    'bullet question .'
    '. answer check'
    '. error .';
  gap: ${space[2]};
  margin: ${space[3]} 0;
`;

export const QuestionBullet = styled(ItemLink).attrs({
  type: 'button',
  isSelected: true,
})`
  grid-area: bullet;
  &:hover {
    cursor: default;
  }
`;

export const ErrorMessage = styled.p`
  grid-area: error;
  margin: 0;
  font-size: ${fontSize.sm};
  color: ${({ theme }) => theme.errorMessage};
`;

export const TitleError = styled.p`
  margin: 0;
  padding: ${space[2]} 0;
  font-size: ${fontSize.md};
  color: ${({ theme }) => theme.errorMessage};
`;

export const TitleGroup = styled.div`
  flex: 1 1 28rem;
  min-width: 0;
  margin-bottom: ${space[3]};
`;

export const AddQuestionButton = styled(Button).attrs(({ $variant }) => ({
  $variant: $variant || 'create',
}))``;

export const DeleteAssessmentButton = styled(Button).attrs(({ $variant }) => ({
  $variant: $variant || 'dangerSecondary',
}))``;

export const Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${space[3]};
  margin-top: ${space[5]};
`;

export const AssessmentNavRow = styled(StaffRow)`
  margin-bottom: ${space[6]};
`;

export const TeacherLabel = styled.p`
  grid-area: check;
  margin: 0;
  font-size: ${fontSize.xs};
  line-height: ${lineHeight.tight};
  color: ${({ theme }) => theme.textDark};
`;

export const Check = ({ form, field, text = 'Teacher Only', ...props }) => {
  const theme = useContext(ThemeContext);
  return (
    <Checkbox
      {...field}
      {...props}
      checked={field.value}
      style={{
        color: theme.lessonHighlight,
        height: 'min-content',
        padding: '0.3em 0',
        gridArea: 'check',
      }}
      icon={
        <div>
          <CheckBoxOutlineBlankRoundedIcon style={{ fontSize: '2.5rem' }} />
          <TeacherLabel>{text}</TeacherLabel>
        </div>
      }
      checkedIcon={
        <div>
          <CheckBoxRoundedIcon style={{ fontSize: '2.5rem' }} />
          <TeacherLabel>{text}</TeacherLabel>
        </div>
      }
    />
  );
};

export const CreateAssessmentButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${space[2]};
  width: 100%;
  height: 100%;
  min-height: 8rem;
  border: none;
  border-radius: ${radius.lg};
  background: none;
  font-family: inherit;
  font-size: ${fontSize.md};
  font-weight: 700;
  color: ${neutral.textMuted};
  cursor: pointer;
  transition: color ${transition.fast};

  &:hover {
    color: ${({ theme }) => theme.headerColour};
  }
  ${focusRing}
`;
